/* eslint-disable import/prefer-default-export */
import styled from '@emotion/styled';
import COLORS from '$variables/colors';
import { spacing, typography } from '$variables/theme';

export const ChipOutline = styled.div`
  border: 1px solid;
  font-size: 14px;
  font-weight: ${typography.fontWeightMedium};
  border-radius: 18px;
  padding: ${spacing.xSmall} ${spacing.medium};
  border-color: ${({ 'aria-invalid': error }) =>
    error ? COLORS.errorRed : COLORS.border1};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  color: ${({ look }) => look.color};
  background-color: ${({ look }) => look.backgroundColor};

  &:hover {
    background: ${({ look }) => look.hoverBgColor};
  }
`;
